import PropTypes from 'prop-types';
import styles from './FJTextToSpeechRight.module.less';
import FJTextToSpeechItemContainer from '../container/FJTextToSpeechItemContainer.jsx';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJUtil from '../../../../util/FJUtil.js';
import { useState, useRef, useEffect, useLayoutEffect, useCallback } from 'react';
import FlipList from '../../../../store/FJFlipList.js';
import FJTextToSpeechBottomContainer from '../container/FJTextToSpeechBottomContainer.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';

const TRANSFORM_OFFSET = 1;
const DRAG_ANIMATION_DURATION = 120;
const SCENE_MARGIN = 10;
const SCROLL_RANGE = 50;
const SCROLL_SPEED = 20;
let _preScrollTop = 0;
let _scrollTimer = null;

const FJTextToSpeechRight = props => {
    const { currentSpeechList: list, updateSpeechListPosition, onSelect, speechSelectId } = props;

    const [stateDragId, setStateDragId] = useState(null);
    const [stateIsDragging, setStateIsDragging] = useState(false);
    const [stateIsScroll, setStateIsScroll] = useState(false);
    const [stateIsScrollUp, setStateIsScrollUp] = useState(false);
    const [stateMouseMoveIndex, setStateMouseMoveIndex] = useState(-1);
    const scrollRef = useRef(null);
    const draggingItemRef = useRef(null);
    const flipListRef = useRef(FlipList);
    const flipItemRef = useRef(FlipList);

    useEffect(() => {
        createNewFlipList(stateDragId);
    }, []);

    useLayoutEffect(() => {
        if (stateDragId && stateIsScroll) {
            let scroll = scrollRef.current.getScroller();
            _scrollTimer = setInterval(() => {
                let scrollTop = scroll.scrollTop + (stateIsScrollUp ? -SCROLL_SPEED : SCROLL_SPEED);
                scrollRef.current.scrollTop(scrollTop);
            }, 16.6);
        } else {
            clearInterval(_scrollTimer);
        }
        return () => {
            clearInterval(_scrollTimer);
        };
    }, [stateIsScroll, stateIsScrollUp, stateDragId]);

    //拖动动画效果
    useEffect(() => {
        return () => {
            stateDragId && __playAnimation();
        };
    }, [stateDragId]);

    useEffect(() => {
        _scrollToVisibleArea();
    }, [speechSelectId]);

    const _scrollToVisibleArea = () => {
        const selectedIndex = list.findIndex(item => item.id === speechSelectId);
        const selectDom = document.getElementById(`text-item-${selectedIndex}`);
        if (!selectDom) {
            return;
        }
        const selectDomRect = selectDom.getBoundingClientRect();

        const scroll = scrollRef.current.getScroller();
        const scrollRect = scroll.getBoundingClientRect();

        // 检查选中项是否在可视区域外
        if (selectDomRect.top < scrollRect.top) {
            // 如果在可视区域上方，向上滚动
            const scrollTop = scroll.scrollTop - (scrollRect.top - selectDomRect.top);
            scrollRef.current.scrollTop(scrollTop);
        } else if (selectDomRect.bottom > scrollRect.bottom) {
            // 如果在可视区域下方，向下滚动
            const scrollTop = scroll.scrollTop + (selectDomRect.bottom - scrollRect.bottom);
            scrollRef.current.scrollTop(scrollTop);
        }
    };

    const __playAnimation = () => {
        if (!scrollRef.current) return;
        scrollRef.current.scrollTop(_preScrollTop);
        //列表动画
        flipListRef.current?.play && flipListRef.current?.play(() => flipListRef.current?.recordFirst());
        //拖拽元素动画
        flipItemRef.current?.play &&
            flipItemRef.current?.play(() => {
                flipItemRef.current?.recordFirst();
                flipItemRef.current.flips[0].dom.style.width = '';
                flipItemRef.current.flips[0].dom.style.height = '';
            });
    };

    /**
     * @desc 记录children位置数据
     * @param {*} id
     * @returns
     */
    const createNewFlipList = id => {
        if (!scrollRef.current.getScroller()) return;
        //记录动画
        const parentNode = scrollRef.current.getScroller();
        let scroll = scrollRef.current.getScroller();

        const children = Array.from(parentNode.children);
        const dragIndex = list.findIndex(item => item.id === id);
        const dragItem = children[dragIndex];
        const listenChildren = [...scrollRef.current.getScroller().children].filter(k => k !== dragItem);
        // const listenChildren = [...scrollRef.current.getScroller().children];
        //列表
        flipListRef.current = new FlipList(listenChildren, DRAG_ANIMATION_DURATION, null, 0);
        flipListRef.current.recordFirst();
        //拖拽元素
        if (dragItem) {
            flipItemRef.current = new FlipList(
                [dragItem],
                DRAG_ANIMATION_DURATION,
                styles.moving_class,
                scroll.scrollTop,
            );
            flipItemRef.current.recordFirst();
        }
    };

    //更新拖拽元素位置
    const _updateDraggingItemPosition = ({ x, y }, type) => {
        if (!draggingItemRef.current) return;
        const HEIGHT = 42;
        if (type === 'start') {
            draggingItemRef.current.style.opacity = 1;
            draggingItemRef.current.style.visibility = 'visible';
            draggingItemRef.current.style.transform = `translate(${x}px, ${y - HEIGHT / 2}px)`;
            document.body.style.cursor = 'grabbing !important';
        } else if (type === 'change') {
            draggingItemRef.current.style.transform = `translate(${x}px, ${y - HEIGHT / 2}px)`;
        } else if (type === 'end') {
            document.body.style.cursor = '';
            draggingItemRef.current.style.opacity = 0;
            draggingItemRef.current.style.visibility = 'hidden';
        }
    };

    // 拖拽元素
    const _renderDraggingItem = () => {
        const item = list.find(item => item.id === stateDragId);
        const index = list.findIndex(item => item.id === stateDragId);
        return (
            <div className={styles.dragging_item} ref={draggingItemRef}>
                <span>{FJLocalStore._('section-xxx').replace('xxx', index + 1)}</span>
                {item?.text}
            </div>
        );
    };

    //更新当前拖动的位置
    const updateMouseMoveSceneIndex = e => {
        if (!scrollRef.current) return;
        const point = FJUtil.calcCursorPoint(e);
        let index = list.findIndex(item => item.id === stateDragId);
        for (let i = 0; i < list.length; i++) {
            const itemDom = document.getElementById(`text-item-${i}`);
            if (!itemDom) {
                return;
            }
            const itemRect = itemDom.getBoundingClientRect();

            if (point.y >= itemRect.top - SCENE_MARGIN / 2 && point.y <= itemRect.bottom + SCENE_MARGIN / 2) {
                if (point.y >= (itemRect.top + itemRect.bottom) / 2) index = i + 1;
                else index = i;
                break;
            }
        }

        setStateMouseMoveIndex(index);
    };

    const updateScroll = e => {
        const point = FJUtil.calcCursorPoint(e);
        const scroll = scrollRef.current.getScroller();
        const scrollRect = scroll.getBoundingClientRect();
        if (point.y - scrollRect.top < SCROLL_RANGE) {
            setStateIsScroll(true);
            setStateIsScrollUp(true);
        } else if (scrollRect.bottom - point.y < SCROLL_RANGE) {
            setStateIsScroll(true);
            setStateIsScrollUp(false);
        } else {
            setStateIsScroll(false);
        }
    };
    const _onDrag = (e, type, options) => {
        const { dragId } = options;
        const point = FJUtil.calcCursorPoint(e);
        _updateDraggingItemPosition(point, type);
        if (type === 'start') {
            setStateDragId(dragId);
            setStateIsDragging(true);
            onSelect(dragId);
        } else if (type === 'change') {
            updateMouseMoveSceneIndex(e);
            updateScroll(e);
            createNewFlipList(dragId);
        } else if (type === 'end') {
            setStateDragId('');
            setStateIsDragging(false);
            updateSpeechListPosition(dragId, stateMouseMoveIndex);
            setStateMouseMoveIndex(-1);

            _preScrollTop = scrollRef.current.getScroller().scrollTop;
        }
    };

    //scene上下偏移
    const dragItemStyle = useCallback(
        (item, index) => {
            let style = {};
            if (index === stateMouseMoveIndex - 1 && list[index].id !== stateDragId) {
                style.transform = `translateY(${-TRANSFORM_OFFSET}px)`;
            } else if (index === stateMouseMoveIndex && list[index].id !== stateDragId) {
                style.transform = `translateY(${TRANSFORM_OFFSET}px)`;
            }
            return style;
        },
        [stateMouseMoveIndex, stateDragId, list],
    );

    const _onScroll = () => {
        // 滚动后位置需要重新记录
        createNewFlipList();
    };

    //增删场景位移动画效果
    useEffect(() => {
        createNewFlipList();
        return () => {
            flipListRef.current?.play && flipListRef.current?.play(() => flipListRef.current?.recordFirst());
        };
    }, [list.length]);

    const dragIndex = list.findIndex(i => i.id === stateDragId);
    return (
        <div className={styles.app_right}>
            <FJVerticalScroller className={styles.scroller} ref={scrollRef} onScroll={_onScroll}>
                <>
                    {list.map((item, index) => {
                        return (
                            <div key={item.id}>
                                {index === 0 ? (
                                    <div
                                        className={styles.drag_line}
                                        style={{ opacity: stateMouseMoveIndex === 0 ? 1 : 0 }}
                                    ></div>
                                ) : null}
                                <FJTextToSpeechItemContainer
                                    key={index}
                                    index={index}
                                    info={item}
                                    isLast={index + 1 === list.length}
                                    onDrag={_onDrag}
                                    dragId={stateDragId}
                                    isDragging={stateIsDragging}
                                    style={dragItemStyle(item, index)}
                                />
                                <div
                                    className={styles.drag_line}
                                    style={{
                                        opacity:
                                            index === stateMouseMoveIndex - 1 &&
                                            dragIndex !== stateMouseMoveIndex &&
                                            dragIndex !== stateMouseMoveIndex - 1
                                                ? 1
                                                : 0,
                                    }}
                                />
                            </div>
                        );
                    })}
                </>
            </FJVerticalScroller>
            {_renderDraggingItem()}
            <FJTextToSpeechBottomContainer />
        </div>
    );
};

FJTextToSpeechRight.propTypes = {
    currentSpeechList: PropTypes.array,
    updateSpeechListPosition: PropTypes.func,
    onSelect: PropTypes.func,
    speechSelectId: PropTypes.number,
};
export default FJTextToSpeechRight;
